<!-- #211 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Tracking Events
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="eventsUpload"
      :loading="loader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-row class="mt-0">
          <v-col cols="12" md="6" class="d-flex flex-column align-left pt-3">
            <v-toolbar-title class="pl-3 text-h6"> Carrier </v-toolbar-title>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end pt-5">
            <div class="d-flex">
              <v-dialog
                v-model="dialog"
                max-width="550px"
                @keydown.esc="dialog = false"
              >
                <v-card>
                  <v-card-title>
                    <span class="headline">Events Upload</span>
                  </v-card-title>
                  <v-divider class="mb-4"></v-divider>
                  <v-card-text>
                    <v-form ref="form" lazy-validation>
                      <v-row>
                        <v-col>
                          <v-file-input
                            v-model="file"
                            counter
                            show-size
                            accept=".xlsx"
                            label="Select your Excel file"
                            outlined
                            :rules="[(v) => !!v || 'Please select Excel File']"
                          >
                          </v-file-input>
                          <v-btn
                            color="primary"
                            dark
                            class="mt-3"
                            :loading="fileLoader"
                            @click="uploadEventsDetails"
                          >
                            Upload
                          </v-btn>
                          <v-btn
                            color="info"
                            class="mt-3 ml-3"
                            :loading="downloader"
                            @click="downloadEventsDetails()"
                            >Download template</v-btn
                          >
                          <v-btn class="mt-3 ml-3" @click="close">
                            Cancel
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <v-btn
                color="primary"
                :loading="fileLoader"
                small
                class="mr-2"
                @click="dialog = true"
                v-if="checkPermission('events-upload') && id && isActive"
                >Upload</v-btn
              >
              <v-btn
                color="info"
                small
                :loading="downloader"
                @click="downloadEventsDetails()"
                class="mr-4"
                v-if="
                  checkPermission(
                    'app_carrier_partner:download_tracking_events'
                  ) && id
                "
                >Download</v-btn
              >
              <v-btn
                color="info"
                small
                @click="callTrackingEvent()"
                v-if="
                  checkPermission(
                    'app_carrier_partner:carrier-events-summary'
                  ) && id
                "
                class="mr-4"
                >Tracking Events</v-btn
              >
            </div>
            <v-select
              v-model="selectedCarriedId"
              label="Carriers"
              :rules="[(v) => !!v || 'Carriers is required.']"
              class="required pt-0 pb-0"
              item-text="name"
              item-value="id"
              :items="activeCarriersListTypes"
              @change="carrierTypeList()"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-divider class="mt-2 mb-2"></v-divider>
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">{{
          item.created_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <span v-if="item.updated_at">{{
          item.updated_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.is_final_event`]="{ item }">
        <div v-if="item.is_final_event === false">No</div>
        <div v-else>Yes</div>
      </template>
      <template v-slot:[`item.event_code`]="{ item }">
        <span
          class="item-status"
          :class="item.rsa_event == null ? 'red' : 'green'"
          v-if="item.summary_status == 'yes'"
          @click="statusFunc(item.summary_count)"
          ><a>{{ item.event_code }}</a></span
        >
        <span v-else>{{ item.event_code }}</span>
      </template>
    </v-data-table>
    <v-dialog
      v-model="statusDialog"
      max-width="550px"
      @keydown.esc="statusDialog = false"
    >
      <template>
        <div>
          <v-toolbar flat>
            <v-toolbar-title class="mb-2"
              >Unique Tracking Events Counts =
              {{ this.counts }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-icon @click="statusDialog = false">mdi-close</v-icon>
          </v-toolbar>
        </div>
      </template>
    </v-dialog>
    <v-dialog
      v-model="detailsDialog"
      max-width="750px"
      @keydown.esc="detailsDialog = false"
    >
      <template>
        <div>
          <v-data-table
            :headers="dialogHeaders"
            :items="dialogList"
            :items-per-page="25"
            item-key="name"
            class="elevation-1"
            :options.sync="option"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template v-slot:item="{ item }">
              <tr
                :class="{ 'highlighted-row': item.rsa_events_status == null }"
              >
                <td v-for="(header, index) in dialogHeaders" :key="index">
                  {{ item[header.value] }}
                </td>
              </tr>
            </template>

            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title class="mb-2"
                  >Unique Tracking Events</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-icon @click="detailsDialog = false">mdi-close</v-icon>
              </v-toolbar>
              <v-divider></v-divider>
            </template>
            <template v-slot:[`item.image_or_data`]="{ item }">
              <v-icon @click="open(item.image_or_data, 3)" v-if="item.flag == 3"
                >mdi-eye-outline</v-icon
              >
              <v-icon @click="open(item.image_or_data, 0)" v-if="item.flag == 0"
                >mdi-eye-outline</v-icon
              >

              <v-icon
                @click="download(item.image_or_data)"
                v-if="item.flag == 1"
                >mdi-eye-outline</v-icon
              >
            </template>
          </v-data-table>
        </div>
      </template>
    </v-dialog>
    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
    />
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: {
    BulkErrors,
  },

  data: () => ({
    dialogList: [],
    dialogHeaders: [
      {
        text: "RSA Event",
        value: "rsa_events_status",
        class: "body-1 font-weight-bold",
        width: "100px",
        sortable: false,
      },
      {
        text: "Carrier Status",
        value: "carrier_tracking_id__event_status",
        class: "body-1 font-weight-bold",
        width: "100px",
        sortable: false,
      },
      {
        text: "Count",
        value: "carrier_tracking_id__count",
        class: "body-1 font-weight-bold",
        width: "100px",
        sortable: false,
      },
    ],
    headers: [
      {
        text: "Carrier Event Name",
        value: "event_name",
        class: "body-1 font-weight-bold",
        width: "150px",
        sortable: false,
      },
      {
        text: "Carrier Event Code",
        value: "event_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Carrier Event Status",
        value: "event_status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Carrier Is Final Event",
        value: "is_final_event",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Summary",
        value: "summary",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "RSA Event",
        value: "rsa_event",
        align: "center",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created At",
        value: "created_at",
        align: "center",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created By",
        value: "created_by",
        align: "center",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated At",
        value: "updated_at",
        align: "center",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated By",
        value: "updated_by",
        align: "center",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    formData: {},
    eventsUpload: [],
    loader: false,
    dialog: false,
    file: null,
    fileLoader: false,
    downloader: false,
    uploadRes: {},
    uploadResDialog: false,
    selectedCarriedId: {
      name: null,
      id: null,
    },
    total: 0,
    options: {},
    option: {},
    detailsDialog: false,
    statusDialog: false,
    id: null,
    counts: 0,
    activeCarriersListTypes: [],
    isActive: true,
  }),

  watch: {
    options: {
      handler() {
        this.fetchEventsList();
      },
      deep: true,
    },
    option: {
      deep: true,
    },
  },

  created() {
    this.selectedCarriedId.name = this.$route.params.name;
    this.selectedCarriedId.id = this.$route.params.id;
    this.id = this.$route.params.id;
    this.fetchEventsList();
    this.fetchCarriers();
  },

  methods: {
    ...mapActions([
      "getEvents",
      "uploadEvents",
      "downloadEvents",
      "getCarriersDropdown",
      "getEventHistory",
      "snackBar",
    ]),
    async fetchCarriers() {
      await this.getCarriersDropdown({
        pagination: 0,
        active: "all",
      })
        .then((res) => {
          this.activeCarriersListTypes = res.data;
        })
        .catch(() => {
          this.loader = false;
        });
      if (
        this.selectedCarriedId.id !== undefined &&
        this.selectedCarriedId.id !== null
      ) {
        this.isActive =
          this.activeCarriersListTypes[this.selectedCarriedId.id].active;
      }
    },
    close() {
      this.dialog = false;
      this.$refs.form?.reset();
    },
    statusFunc(count) {
      this.statusDialog = true;
      this.counts = count;
    },
    callTrackingEvent() {
      if (this.id == null) {
        this.snackBar({
          color: "error",
          message: "Carrier is required",
        });
      } else {
        this.getEventHistory({
          id: this.id,
          params: {
            ...this.option,
          },
        }).then((res) => {
          this.detailsDialog = true;
          this.dialogList = res.data[0].all_data;
        });
      }
    },
    fetchEventsList() {
      if (this.$route.query.carrier_id !== undefined) {
        this.loader = true;
        this.getEvents({
          carrier_id: this.$route.query.carrier_id,
          params: {
            ...this.options,
          },
        })
          .then((res) => {
            this.loader = false;
            this.eventsUpload = res.data.records;
            this.total = res.data.total;
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    uploadEventsDetails() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file);
      payload.append("carrier_id", this.$route.query.carrier_id);
      this.uploadEvents(payload)
        .then((res) => {
          this.fileLoader = false;
          this.dialog = false;
          this.uploadRes = res.data;
          this.uploadResDialog = true;
          this.fetchEventsList();
        })
        .catch(() => {
          this.fileLoader = false;
        });
    },
    downloadEventsDetails() {
      this.downloader = true;
      const payload = new FormData();
      payload.append("carrier_id", this.$route.query.carrier_id);
      this.downloadEvents(payload)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    carrierTypeList() {
      this.$route.query.carrier_id = this.selectedCarriedId;
      this.id = this.selectedCarriedId;
      this.$router.replace({
        params: {
          id: this.$route.params.id,
          name: this.$route.params.name,
        },
        query: { carrier_id: this.selectedCarriedId },
      });
      this.fetchEventsList();
      this.checkActive();
    },
    checkActive() {
      let carrier = this.activeCarriersListTypes.findIndex(
        (e) => e.id == this.selectedCarriedId
      );
      this.isActive = this.activeCarriersListTypes[carrier].active;
    },
  },
};
</script>
<style scoped>
.item-status a {
  font-size: 12px; /* Increase or decrease the font size as desired */
  font-weight: 400; /* Increase or decrease the font weight as desired */
  padding: 5px 10px; /* Adjust the padding as desired */
  text-decoration: none; /* Remove underline if necessary */
}
.red {
  background-color: red;
}
.green {
  background-color: green;
}
.highlighted-row {
  background-color: orange;
}
</style>
